import { render, staticRenderFns } from "./daily-collection-schedule.vue?vue&type=template&id=586ea4dd&"
import script from "./daily-collection-schedule.vue?vue&type=script&lang=js&"
export * from "./daily-collection-schedule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports